import React from "react";
import {Navigate, useLocation} from "react-router-dom";

export const RedirectToLogin = () => {
    const location = useLocation();
    const redirectParam = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirectParam}`} replace />;
};

export const RedirectToTokenRefresh = () => {
    const location = useLocation();
    const redirectParam = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/refresh-token?redirect=${redirectParam}`} replace />;
};

export const RedirectAuthenticated = () => {
    const [searchParams] = [new URLSearchParams(useLocation().search)];
    return <Navigate to={searchParams.get('redirect') || '/'} replace />;
};